export default __webpack_public_path__ + "static/product9-9e63bab0c5ca321b15346ee39032a973.jpg";